import css from '../../../utils/css';

export default css`
  :host {
    --widget-font-family: 'DM Sans', sans-serif;

    --chiamarsi-bomber-black: rgba(54, 64, 83, 0.3);
    --chiamarsi-bomber-white: #fff;
    --chiamarsi-bomber-pure-black: #000;
    --chiamarsi-bomber-red: #e31b54;
    --chiamarsi-bomber-drifting: #efc5d1;
    --chiamarsi-bomber-shortening: #b0bcd3;
    --chiamarsi-bomber-blue-grey: #364053;
    --oc-text-body: var(--chiamarsi-bomber-pure-black);
    --ogm-grid-main-border-color: var(--chiamarsi-bomber-blue-grey);
    --oc-bg-grey-light: var(--chiamarsi-bomber-white);
    --oc-box-shadow: var(--chiamarsi-bomber-white);
    --ogm-grid-offer-color: var(--chiamarsi-bomber-pure-black);

    --widget-grid-compare-color: var(--chiamarsi-bomber-pure-black);
    --ogm-grid-compare-bg-color: var(--chiamarsi-bomber-white);
    --ogm-text-body: var(--chiamarsi-bomber-white);
    --ogm-grid-odds-tooltip-bg-color: #101319;

    --widget-odds-shortening-bg: var(--chiamarsi-bomber-shortening);
    --widget-odds-shortening: var(--chiamarsi-bomber-shortening);

    --widget-odds-drifting-bg: var(--chiamarsi-bomber-drifting);
    --widget-odds-drifting: var(--chiamarsi-bomber-drifting);

    --widget-header-text-color: var(--chiamarsi-bomber-white);
    --widget-background-color: #101319;
    --widget-grid-compare-bg-color: var(--chiamarsi-bomber-white);

    --widget-grid-compare-active-color: var(--chiamarsi-bomber-pure-black);
    --widget-grid-odds-bg-color: var(--chiamarsi-bomber-white);
    --widget-grid-odds-border-color: var(--chiamarsi-bomber-white);

    --widget-text-color: var(--chiamarsi-bomber-white);
    --widget-subtext-color: var(--chiamarsi-bomber-white);

    --widget-header-bg-color: #101319;
    --widget-header-text-color: var(--chiamarsi-bomber-white);
    --widget-header-odds-shadow: #ccc;

    --widget-grid-odds-text-color: var(--chiamarsi-bomber-pure-black);

    --widget-grid-best-odds-border-color: transparent;
    --widget-grid-best-odds-text-color: var(--chiamarsi-bomber-white);
    --widget-grid-best-odds-bg-color: var(--chiamarsi-bomber-red);
    --widget-grid-best-odds-mobile-bg-color: var(--chiamarsi-bomber-red);
    --widget-grid-best-odds-mobile-border-color: var(--chiamarsi-bomber-red);

    --widget-grid-ribbon-color: var(--chiamarsi-bomber-white);
    --widget-grid-compare-active-bg-color: var(--chiamarsi-bomber-white);

    [class*='BetRowLeftBetContent'],
    [class*='QuickBetTitleWrapper'] {
      background: unset;
    }

    span[class*='oddShortening'] > button:not([class*='bestOddsStyles']) {
      background-color: var(--oc-odds-shortening-bg) !important;
      border-color: var(--oc-odds-shortening-bg) !important;
      color: var(--chiamarsi-bomber-pure-black) !important;
      font-weight: normal !important;
    }

    span[class*='oddDrifting'] > button:not([class*='bestOddsStyles']) {
      background-color: var(--oc-odds-drifting-bg) !important;
      --widget-grid-odds-border-color: var(--oc-odds-drifting-bg) !important;
    }

    [class*='OddsActionsWrapper'] [class*='Button_']:not([class*='activeBtn']) {
      color: var(--chiamarsi-bomber-pure-black) !important;
    }
  }
`;
